module.exports = __webpack_public_path__ + "media/workplace/fast-track-icon-26bfed26.svg";